import PropTypes from "prop-types"

export const MODEL_METADATA_SHAPE = PropTypes.shape({
  id: PropTypes.string.isRequired,
  name: PropTypes.string.isRequired,
  shortName: PropTypes.string,
  supportedCurrencies: PropTypes.arrayOf(PropTypes.string),
  missingDataFiles: PropTypes.arrayOf(PropTypes.string),
  defaultBenchmark: PropTypes.string,
  topFactors: PropTypes.arrayOf(PropTypes.string),
  linkedFactors: PropTypes.arrayOf(PropTypes.shape({
    id: PropTypes.string.isRequired,
    factors: PropTypes.arrayOf(PropTypes.string).isRequired,
  })),
  categories: PropTypes.arrayOf(PropTypes.shape({
    id: PropTypes.string.isRequired,
    label: PropTypes.string.isRequired,
    singleFactor: PropTypes.bool,
    color: PropTypes.string,
    background: PropTypes.string,
  })),
  factors: PropTypes.arrayOf(PropTypes.shape({
    id: PropTypes.string.isRequired,
    label: PropTypes.string.isRequired,
    category: PropTypes.string.isRequired,
    alias: PropTypes.string,
  })),
  availability: PropTypes.shape({
    currentDate: PropTypes.string,
    securitiesStartDate: PropTypes.string,
    unmodeledDates: PropTypes.arrayOf(PropTypes.string),
  }),
})

export const INSTRUMENT_METADATA_SHAPE = PropTypes.shape({
  id: PropTypes.string.isRequired,
  name: PropTypes.string.isRequired,
  type: PropTypes.string.isRequired,
  experimentId: PropTypes.string,
})

export const FLATTENED_METRIC_SHAPE = PropTypes.shape({
  id: PropTypes.string.isRequired,
  label: PropTypes.string.isRequired,
  category: PropTypes.string,
  dataPath: PropTypes.string,
  format: PropTypes.string,
  selector: PropTypes.string,
  metricTypeOptions: PropTypes.array,
  isDefault: PropTypes.bool,
  shouldHide: PropTypes.func,
  tooltipContents: PropTypes.oneOfType([
    PropTypes.string,
    PropTypes.func,
  ]),
})

export const INSTRUMENT_COLUMNS = PropTypes.arrayOf(PropTypes.oneOf([
  "original",
  "rebalanced",
  "comparison",
  "delta",
]))

const TIER_SHAPE = PropTypes.shape({
  id: PropTypes.string.isRequired,
  level: PropTypes.number.isRequired,
  name: PropTypes.string.isRequired,
})

export const CLASSIFICATION_SHAPE = PropTypes.shape({
  id: PropTypes.string.isRequired,
  name: PropTypes.string.isRequired,
  proprietary: PropTypes.bool.isRequired,
  versions: PropTypes.arrayOf(PropTypes.shape({
    id: PropTypes.string.isRequired,
    asOf: PropTypes.string.isRequired,
    tiers: PropTypes.arrayOf(TIER_SHAPE).isRequired,
  })).isRequired,
})

export const INSTRUMENTS_WITH_METADATA_SHAPE = PropTypes.shape({
  original: PropTypes.object,
  rebalanced: PropTypes.object,
  comparison: PropTypes.object,
  base: PropTypes.object,
})

export const CLASSIFICATIONS_SHAPE = PropTypes.arrayOf(CLASSIFICATION_SHAPE)

export const COLUMN_ORDER_SHAPE = PropTypes.oneOf(["default", "original", "rebalanced", "comparison", "delta"])
